import { registerPlugin } from "@capacitor/core";

export type CameraPermissionStatus =
  | "notDetermined"
  | "restricted"
  | "denied"
  | "authorized"
  | "unknown";

export interface PermissionStatusResult {
  status: number;
  statusName: CameraPermissionStatus;
}

export interface NativeCameraPlugin {
  /**
   * Get current camera permission status.
   * Returns the iOS authorization level.
   */
  getPermissionStatus(): Promise<PermissionStatusResult>;

  /**
   * Request camera permission.
   * Triggers the iOS permission dialog if not yet determined.
   */
  requestPermission(): Promise<PermissionStatusResult>;
}

const NativeCamera = registerPlugin<NativeCameraPlugin>("NativeCamera", {
  web: () =>
    import("./native-camera-web").then((m) => new m.NativeCameraWeb()),
});

export default NativeCamera;
